import 'react';
import './Provider/ThemeContext.js';
import 'classnames';
import { css } from 'emotion';
import '@emotion/core';
import 'emotion-theming';
import '@emotion/styled';
import { a as _taggedTemplateLiteralLoose } from './_rollupPluginBabelHelpers.js';
import './ColorMode/ColorModeContext.js';
import 'lodash/kebabCase';
import 'tinycolor2';
import { t as theme, p as palette, s as space } from './getCSSFromStyleObject.js';
import 'lodash/uniq';
import 'reakit/Id';
import 'deepmerge';
import 'lodash/set';
import 'lodash/get';
import 'capsize';
import { getHiddenScrollbarStyles } from './utils/getHiddenScrollbarStyles.js';
import '@emotion/is-prop-valid';
import './utils/OutsideClickHandler.js';

function _templateObject10() {
  var data = _taggedTemplateLiteralLoose(["\n  max-height: calc(", " - 1rem);\n  overflow-y: scroll;\n\n  ", ";\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteralLoose(["\n  & {\n    ", ";\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n  & {\n    ", ";\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: ", "rem ", "rem;\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n  align-items: center;\n  justify-content: center;\n  padding: ", "rem ", "rem;\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n  padding: ", "rem ", "rem;\n  width: 100%;\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  & {\n    ", ";\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n  &&& {\n    font-weight: 300;\n\n    &[aria-selected=\"true\"] {\n      background-color: ", ";\n    }\n\n    &[aria-disabled=\"true\"] {\n      color: ", ";\n    }\n  }\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  &&& {\n    max-width: 100%;\n    width: 100%;\n    max-height: ", ";\n  }\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n\n  & {\n    ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var Autosuggest = function Autosuggest(styleProps) {
  return css(_templateObject(), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var AutosuggestPopover = function AutosuggestPopover(styleProps) {
  return css(_templateObject2(), styleProps.popoverHeight, theme(styleProps.themeKey, "styles.base")(styleProps));
};
var AutosuggestItem = function AutosuggestItem(styleProps) {
  return css(_templateObject3(), palette('white600')(styleProps), palette('gray100')(styleProps), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var AutosuggestItemText = function AutosuggestItemText(styleProps) {
  return css(_templateObject4(), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var AutosuggestStaticItem = function AutosuggestStaticItem(styleProps) {
  return css(_templateObject5(), space(1.5)(styleProps), space(4)(styleProps), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var AutosuggestClearButtonWrapper = function AutosuggestClearButtonWrapper(styleProps) {
  return css(_templateObject6(), space(1)(styleProps), space(2)(styleProps), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var AutosuggestClearButton = function AutosuggestClearButton(styleProps) {
  return css(_templateObject7(), space(1)(styleProps), space(2)(styleProps), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var AutosuggestInput = function AutosuggestInput(styleProps) {
  return css(_templateObject8(), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var AutosuggestField = function AutosuggestField(styleProps) {
  return css(_templateObject9(), theme(styleProps.themeKey, "styles.base")(styleProps));
};
var ItemsWrapper = function ItemsWrapper(styleProps) {
  return css(_templateObject10(), styleProps.popoverHeight, getHiddenScrollbarStyles(), theme(styleProps.themeKey, "styles.base")(styleProps));
};

var Autosuggest_styles = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Autosuggest: Autosuggest,
  AutosuggestPopover: AutosuggestPopover,
  AutosuggestItem: AutosuggestItem,
  AutosuggestItemText: AutosuggestItemText,
  AutosuggestStaticItem: AutosuggestStaticItem,
  AutosuggestClearButtonWrapper: AutosuggestClearButtonWrapper,
  AutosuggestClearButton: AutosuggestClearButton,
  AutosuggestInput: AutosuggestInput,
  AutosuggestField: AutosuggestField,
  ItemsWrapper: ItemsWrapper
});

export { Autosuggest_styles as A, ItemsWrapper as I, Autosuggest as a, AutosuggestPopover as b, AutosuggestInput as c, AutosuggestClearButtonWrapper as d, AutosuggestClearButton as e, AutosuggestItemText as f, AutosuggestItem as g, AutosuggestStaticItem as h, AutosuggestField as i };
